import $ from "jquery";
const blogBanner = {
    methods: {
        init: function () {
            const wrapper = $(".blog-banner__wrapper");
            const gradientColor = wrapper.attr("data-bg-gradient");
            if (gradientColor) {
                wrapper.css("background", `linear-gradient(${gradientColor}, rgba(0, 0, 0, 0))`);
            }
        },
        wrapTabViewFields: function () {
            const form = $(".blog-banner .generic-form__frame");
            if (!form.length) {return;}

            const nameField = form.find(".generic-form__group:has(input[name='name'])");
            const mobileField = form.find(".generic-form__group:has(input[name='mobileNo'])");
            const emailField = form.find(".generic-form__group:has(input[name='emaiID'])");

            const fields = [nameField, mobileField, emailField].filter(f => f.length);
            if (!fields.length) {return;}

            const wrapper = $("<div class='form-tab-view'></div>");
            fields[0].before(wrapper);
            fields.forEach(f => wrapper.append(f));
        },
    },
};

$(() => {
    if ($(`.blog-banner`).length) {
        blogBanner.methods.init();
        blogBanner.methods.wrapTabViewFields();
    }
});
